<template>
  <gmap-info-window
    v-if="infoWindow.visible"
    :options="options"
    :position="infoWindow.item.latlon"
    :opened="true"
    style="border-radius: 5px"
    @closeclick="close"
  >
    <div class="text-default text-small" style="padding: 0.5rem">
      <h4>
        <a class="link" :href="infoWindow.item.url">
          {{ infoWindow.item.title }}
          <icon
            v-if="infoWindow.item.isAsvz"
            icon-id="logo"
            :classes="['icon--inline']"
          />
        </a>
      </h4>
      <p class="mrgb0">
        {{ infoWindow.item.subtitle }}
      </p>
    </div>
  </gmap-info-window>
</template>

<script>
import Icon from '@/components/Ui/Icon'
import { mapState } from 'vuex'

export default {
  components: {
    Icon
  },
  props: {},

  data() {
    return {
      options: {
        disableAutoPan: false,
        zindex: 2,
        maxWidth: 300,
        pixelOffset: {
          width: 0,
          height: -45
        }
      }
    }
  },

  computed: {
    ...mapState('Facilities', {
      infoWindow: (state) => state.infoWindow
    })
  },

  methods: {
    close() {
      this.$store.dispatch('Facilities/hideInfoWindow')
    }
  }
}
</script>
